// Mirrors the backend `FinancialTransactionItem.ResponsibleType` enum (1–7) so
// the FE can compare against the `responsible_type` the API returns. Each type
// with a dedicated control branch in ProjectViewFinancePersonSelect:
// CONTRACTOR/TEAM_MEMBER (entity select), EXPENSE (combined stakeholder picker),
// CUSTOMER (auto-filled name), SUPPLIER (supplier list plus inline create).
// MISCELLANEOUS and REIMBURSEMENT have no branch of their own — they
// fall through to the broad free-text party picker. All three of SUPPLIER,
// MISCELLANEOUS and REIMBURSEMENT still store a free-text payee name in
// `custom_subcontractor_name`; SUPPLIER differs only in offering to create a
// Supplier record from what was typed. REIMBURSEMENT is kept (not dropped)
// because the backend actively assigns it; removing it here would desync the
// FE enum from the backend.
const RESPONSIBLE_TYPES = {
  SUPPLIER: 1,
  CONTRACTOR: 2,
  CUSTOMER: 3,
  TEAM_MEMBER: 4,
  MISCELLANEOUS: 5,
  REIMBURSEMENT: 6,
  EXPENSE: 7
} as const

type ResponsibleTypeKeys = keyof typeof RESPONSIBLE_TYPES
type ResponsibleType = (typeof RESPONSIBLE_TYPES)[ResponsibleTypeKeys]

export { RESPONSIBLE_TYPES, type ResponsibleType }
